// import logo from './logo.svg';
import './App.css';
import Navbar from './Components/Navbar';
import Textform from './Components/Textform';
//import About from './Components/About';
import { useState } from 'react';
import Alert from './Components/Alert';
import React from "react";
import About from './Components/About';
// import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  const [mode,setMode] = useState('light'); // wheather dark mode is enabled or not
  const [alert,setAlert]= useState(null);  // use to show the alert message

    function showAlert(message,type){
      setAlert({
         msg: message,
         type:type
      });
      setTimeout(() =>{
        setAlert(null);
      },1500);
    }

  function Togglemode(){
    if(mode==='light'){
      setMode('dark');
      document.body.style.backgroundColor='#042743';
      showAlert("Darkmode has been Enabled","success");
    }
    else{
      setMode('light');
      document.body.style.backgroundColor='white';
      showAlert("Lightmode has been Enabled","success");
    } 
  }
  return (
    <>
   <BrowserRouter>
    <Navbar title="TextUtils" mode={mode} Togglemode={Togglemode}/>
    <Alert alert={alert}/>
   <div className="container">
    <Routes>
         <Route exact path='/' element={<Textform  showAlert={showAlert} heading ="Try TextUtils - Word Counter, Character Counter, Remove Extra Spaces  " mode={mode}/>}/>
         <Route exact path='about' element = {<About/>}/>
    </Routes>
   </div>
   </BrowserRouter>
   </>
  );
}

export default App;
